<template>
    <div>
        <el-row type="flex" class="title-bar" justify="space-between" align="middle">
            <el-col>
                <h1>{{title}}</h1>
            </el-col>
            <el-col style="text-align: right;">
            </el-col>
        </el-row>

        <el-row>
            <el-col class="main--right" :span="24">
                <el-row>
                    <el-col :span="12" style="min-height: 51px;">
                        <el-autocomplete
                            class="inline-input"
                            v-model="search_keyword"
                            :fetch-suggestions="fetch_search_suggestions"
                            placeholder="搜尋"
                            clearable
                            prefix-icon="el-icon-search"
                        ></el-autocomplete>
                        <el-button 
                            @click="handle_search_button_clicked"
                            style="margin-left: 22px"
                        >
                            搜尋
                        </el-button>
                    </el-col>
                </el-row>

                <el-row>
                    <el-table
                        :data="table_data"
                    >
                        <el-table-column
                            key="words"
                            label="同義詞彙"
                        >
                            <template slot-scope="scope">
                                <InputTag 
                                    :read-only="mode[scope.$index]==='view'"
                                    v-model="table_data[scope.$index]['words']"
                                    :add-tag-on-blur="true"
                                ></InputTag>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" v-if="typeof row_actions !== 'undefined' && !(Object.entries(row_actions).length === 0 && row_actions.constructor === Object)">
                            <template slot-scope="scope">
                                <el-button
                                    v-for="(action, idx) in row_actions"
                                    v-show="!action['show_mode'] || mode[scope.$index] === action['show_mode']"
                                    :key="idx"
                                    size="mini"
                                    :type="action.type"
                                    @click="handle_row_action(action.action, scope.$index, scope.row)">{{action.label}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <span class="aux-info-text">輸入關鍵字後直接按enter，即可新增</span>
                </el-row>
                <el-row>
                    <el-button 
                        type="primary"
                        @click="handle_add_action"
                        style="margin: 22px 0"
                    >
                        新增同義詞組
                    </el-button>
                </el-row>
                <el-row>
                    <el-pagination
                        @size-change="handle_page_size_change"
                        @current-change="handle_current_page_change"
                        :current-page="current_page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="single_page_size"
                        :total="resource_total"
                        layout="total, sizes, prev, pager, next, jumper">
                    </el-pagination>
                </el-row>
            </el-col>
        </el-row>

        <LoadingBlock
            :active="loading > 0 || this.initing">
        </LoadingBlock>
    </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import InputTag from 'vue-input-tag'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
        LoadingBlock,
        InputTag
    },
    created () {
      this.permission_check({
        resource_info: { name: this.page_name.PAGE_SYNONYM_MANAGEMENT },
        access: { name: this.permission.VIEW },
        reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
      })

      this.udpate_view()
    },
    data() {
      return {
        title: '同義詞彙設定',
        loading: 0,
        initing: true,
        resource_total: 0,
        table_data: [],
        mode: [],
        single_page_size: 10,
        table_order_by: {field:'', order:''},
        search_history: [
            { "value": "羅東" },
            { "value": "宜蘭" },
            { "value": "太平山"}],
        search_keyword: '',
        current_page: 1,
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/synonym',
        row_actions: {
          edit: {
            label: '編輯',
            action: 'edit',
            show_mode: 'view',
          },
          cancel: {
            label: '取消',
            action: 'cancel',
            show_mode: 'edit',
          },
          save: {
            label: '儲存',
            action: 'save',
            show_mode: 'edit',
            type: 'primary'
          },
          delete: {
            label: '刪除',
            action: 'delete',
            type: 'danger'
          },
        },
      }
    },
    methods: {
        udpate_view: _.debounce( function () {
            this.update_view_immediately()
        }, 1000),
        update_view_immediately : function () {
            this.get_table_content()
        },
        get_serach_params: function () {
            let params = {}

            // search
            if (this.search_keyword) {
                params['words'] = {
                    'value': this.search_keyword.split(' '),
                    'action': 'like'
                }
            }

            // pagination
            params['page_num'] = this.current_page
            params['page_limit'] = this.single_page_size

            return params
        },
        get_table_content: function () {
            console.log('Synonym: get_table_content:' + this.resource_name)

            let params = this.get_serach_params()
            console.log('Synonym: get_table_content, param: ', params)

            this.loading += 1
            axios.post(this.resource_api+'/list', params) 
                .then((response) => {
                this.loading -= 1
                this.initing = false
                console.log('Synonym: list reponse: ', response.data.payload)
                     if (response.data.success) {
                        if (this.current_page === response.data.payload.page_num ){
                            this.resource_total = response.data.payload.search_count
                            this.table_data = response.data.payload.search_result
                            this.mode = []
                            for (let idx in this.table_data) {
                                this.mode.push('view')
                                this.table_data[idx]['words'] = this.table_data[idx]['words'].split(';')
                            }
                        }
                        else {
                            console.log('Synonym: page number not match. Skip updating.')
                        }
                    }
                    else {
                        this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', response.data.message)
                    }
                })
                .catch(err => {
                    this.loading -= 1
                    this.initing = false
                    console.log(err)
                    this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
                })
        },
        handle_page_size_change (size) {
            console.log('page size: ', size)
            this.single_page_size = size
            this.current_page = 1
            this.update_view_immediately()
        },
        handle_current_page_change (page) {
            console.log('current page:', page)
            this.current_page = page
            this.update_view_immediately()
        },
        fetch_search_suggestions (queryString, cb) {
            var search_history = this.search_history;
            var results = queryString ? search_history.filter(this.create_filter(queryString)) : search_history;
            cb(results);
        },
        create_filter (queryString) {
            return (keyword) => {
                return (keyword.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handle_search_button_clicked () {
            this.current_page = 1
            this.update_view_immediately()
        },
        do_search () {
            this.current_page = 1
            this.update_view_immediately()
        },
        handle_row_action (action, index, row) {
            console.log('Synonym: action:' + action + ', index: ' + index + ', row: ', row)

            switch(action){
                case 'edit': 
                    this.$set(this.mode, index, 'edit')
                    break
                case 'save': 
                    this.handle_save_action(index, row)
                    break
                case 'cancel': 
                    this.handle_cancel_action(index, row)
                    break
                case 'delete': 
                    this.handle_delete_action(index, row)
                    break
                default:
                    break
            }
        },
        handle_delete_action(index, row) {
            console.log('Synonym: delete id=', row.id)
            
            if (!row.id) {
                this.handle_cancel_action(index, row)
                return 
            }

            this.$set(this.mode, index, 'view')

            this.loading += 1
            axios.post(this.resource_api+'/delete', {
                id: row.id
            }).then((response) => {
                this.loading -= 1
                this.initing = false
                console.log('Synonym: delete reponse: ', response.data.payload)
                if (response.data.success) {
                    this.update_view_immediately()
                }
                else {
                    console.log('[ERR] Synonym: failed to delete, msg=', response.message)
                    this.notify_message(this.ERROR.LEVEL.ERROR, '無法刪除', response.data.message)
                }
            })
            .catch(err => {
                this.loading -= 1
                this.initing = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法刪除', this.ERROR.MSG.general_err_msg)
            })
        },
        handle_save_action(index, row) {
            console.log('Synonym: save id=', row.id)

            this.$set(this.mode, index, 'view')

            this.loading += 1

            let action = ''
            let params = {}
            if (row.id) {
                action = 'edit'
                params =  {
                    id: row.id,
                    words: this.table_data[index]['words'].join(';')
                }
            }
            else {
                action = 'add'
                params =  {
                    words: this.table_data[index]['words'].join(';')
                }
            }
            
            axios.post(`${this.resource_api}/${action}`, params)
                .then((response) => {
                    this.loading -= 1
                    this.initing = false
                    console.log(`Synonym: ${action} reponse: `, response.data.payload)
                    if (response.data.success) {
                        this.update_view_immediately()
                    }
                    else {
                        console.log(`[ERR] Synonym: failed to ${action}, msg=`, response.data.message)
                        this.notify_message(this.ERROR.LEVEL.ERROR, '無法刪除', response.data.message)
                    }
                })
                .catch(err => {
                    this.loading -= 1
                    this.initing = false
                    console.log(err)
                    this.notify_message(this.ERROR.LEVEL.ERROR, '無法儲存', this.ERROR.MSG.general_err_msg)
                })
        },
        handle_add_action() {
            console.log('Synonym: add')

            this.mode.push('edit')
            this.table_data.push({id: null, words:[]})
        },
        handle_cancel_action(index, row) {
            console.log('Synonym: cancel index=', index)

            this.$set(this.mode, index, 'view')

            if (!row.id) {
                this.mode.splice(index, 1)
                this.table_data.splice(index, 1)
            }
        },
    }
  };
</script>

<style lang="scss" scoped>
/deep/.el-checkbox+.el-checkbox {
  margin-left: 0;
  display: block;
  padding: 5px 0;
}
.el-checkbox-group {
  margin: 10px 0 10px 5px;
}
/deep/ .el-checkbox__label {
  white-space: initial;
  word-break: break-all;
  word-wrap: break-word;
  vertical-align: top;
  position: relative;
  top: 0;
  top: -2px\0;
}
.el-form-item {
  margin-bottom: 10px;
}
.title-bar {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 32px;
}
.el-table .el-button {
  margin: 0 5px 5px 0;
}
.el-pagination {
  margin: 10px 0;
}
.filter-aside {
  border-right: 1px solid #dcdfe6;
  padding-right: 16px;
}
.main--right {
  padding-left: 16px;
}
.sub-category {
  .el-checkbox:before {
    content: '- ';
    color: #ddd;
  }
}

.aux-info-text {
    color: #aaa;
}
</style>
